
/*
  This file is auto-generated by generate-icon-components.js. Do not edit it manually.
*/
import { html, css, LitElement } from "lit";
import { customElement, property } from "lit/decorators.js";

export const FhiIconSendSelector = "fhi-icon-send";

/**
 * ## FhiIconSend
 * 
 * {@link https://designsystem.fhi.no/?path=/docs/ikoner--docs}
 * 
 * @tag fhi-icon-send
 * @element fhi-icon-send
 */
@customElement(FhiIconSendSelector)
export class FhiIconSend extends LitElement {

  /**
   * Sets the color for the icon.
   * Should preferably be a color token. See [Color Tokens](https://designsystem.fhi.no/?path=/docs/design-tokens-farger--docs)
   * @type {string}
   */ 
  @property({ type: String }) color: string = "currentcolor";

  /**
   * Sets the size of the icon. Can be one of the predefined sizes, a number value, rem or px.
   * Number values are treated as px.
   * @type { 'xsmall' | 'small' | 'medium' | 'large' | number | string}
   */
  @property({ type: String }) size: 'xsmall' | 'small' | 'medium' | 'large' | number | `${number}px` | `${number}rem` = 'medium';

  private get _size(): string {
    switch (this.size) {
      case 'xsmall': 
        return '1rem'; 
      case 'small':
        return '1.25rem';
      case 'medium':
        return '1.5rem'; 
      case 'large':
        return '2rem'; 
      default:
        if (String(this.size).endsWith('px') || String(this.size).endsWith('rem')) {
          return String(this.size);
        }
        if (isNaN(Number(this.size))) {
          console.warn(`Invalid size value: ${this.size}. Falling back to default size '1.5rem'.`)
          return '1.5rem';
        }
        return `${this.size}px`;
    }
  }

  render() {
    return html`
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="${this._size}" height="${this._size}" fill="${this.color}"><path d="M22.023 1.252a1 1 0 0 1 .096.009l.034.004q.06.013.118.036l.035.015a1 1 0 0 1 .127.072l.023.017a.8.8 0 0 1 .138.138l.015.021.026.04a1 1 0 0 1 .046.087l.017.037a1 1 0 0 1 .035.118l.005.036a1 1 0 0 1 .01.094v.038a.8.8 0 0 1-.04.234l-7 20a.75.75 0 0 1-1.393.056l-3.883-8.736-8.737-3.883a.75.75 0 0 1 .057-1.393l20-7a.8.8 0 0 1 .233-.041zM11.895 13.165l3.022 6.8 5.287-15.11zM4.033 9.082l6.801 3.022 8.312-8.311z"/></svg>
    `;
  }
      
  static styles = css`
    :host {
      display: flex;
      max-height: min-content;
      max-width: min-content;
    }
  `;
  }
